import axios from "axios";
import { BASE_URL, POINTS_URL } from "../ApiConstant";

export const tournamentPointsLoading = () => {
  return {
    type: "TOURNAMENT_POINTS_LOADING",
  };
};

export const tournamentPointsSuccess = (points) => {
  return {
    type: "TOURNAMENT_POINTS_SUCCESS",
    points,
  };
};

export const tournamentPointsError = (error) => {
  return {
    type: "TOURNAMENT_POINTS_ERROR",
    error,
  };
};

const getFormattedDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};

const extractConfigDate = (data) => {
  const candidate = (Array.isArray(data) ? data[0] : data) ?? "";

  if (typeof candidate === "string") {
    const trimmed = candidate.trim();
    if (!trimmed) return "";
    if (trimmed.includes("T")) return trimmed.split("T")[0];
    if (trimmed.includes(" ")) return trimmed.split(" ")[0];
    return trimmed;
  }

  if (typeof candidate === "number") {
    return getFormattedDate(candidate);
  }

  if (candidate && typeof candidate === "object") {
    const possible =
      candidate.start_date ??
      candidate.startDate ??
      candidate.startdate ??
      candidate.end_date ??
      candidate.endDate ??
      candidate.enddate ??
      candidate.value ??
      candidate.config_value ??
      candidate.configValue ??
      "";
    return extractConfigDate(possible);
  }

  return "";
};

const fetchTournamentStartDate = async () => {
  try {
    const resp = await axios.get(
      `${BASE_URL}siteapi/getgeneralconfig/tournement_start_date`
    );
    return extractConfigDate(resp?.data);
  } catch (e) {
    return "";
  }
};

const fetchTournamentEndDate = async () => {
  try {
    const resp = await axios.get(
      `${BASE_URL}siteapi/getgeneralconfig/tournement_end_date`
    );
    return extractConfigDate(resp?.data);
  } catch (e) {
    return "";
  }
};

export const fetchTournamentPoints = () => {
  return async (dispatch) => {
    dispatch(tournamentPointsLoading());

    const [configuredStartDate, endDate] = await Promise.all([
      fetchTournamentStartDate(),
      fetchTournamentEndDate(),
    ]);
    const startDate = configuredStartDate || getFormattedDate(new Date());

    if (!endDate) {
      dispatch(tournamentPointsSuccess(0));
      return;
    }

    let points = 0;
    try {
      const resp = await axios.get(
        POINTS_URL + `?startdate=${startDate}&enddate=${endDate}`
      );
      if (resp?.data?.points > 0) {
        points = Math.floor(resp?.data?.points);
      }

      dispatch(tournamentPointsSuccess(points));
    } catch (error) {
      dispatch(tournamentPointsError(error));
    }
  };
};
